import { apiSlice } from "../api/apiSlice";

export const consumptionReportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generatorConsumptionReport: builder.mutation({
      query: (data) => ({
        url: "/apiV2/generator/oil_electricity_consumption",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useGeneratorConsumptionReportMutation } = consumptionReportApi;
